import React, { ReactNode } from 'react';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';

interface MbwSpeakerItemProps {
  onClick?: () => void;
  children?: ReactNode;
}
const MbwSpeakerButton = ({ onClick, children }: MbwSpeakerItemProps) => {
  const event = useSelector((state) => state.common.event);
  return (
    <div onClick={() => onClick?.()} className="flex items-center justify-center border-2 cursor-pointer ">
      {children}
    </div>
  );
};

export default MbwSpeakerButton;
